import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ColudExtractComponent } from "./colud-extract/colud-extract.component";
import { RouterModule, Routes } from "@angular/router";
import { CloudExtractLoadHomeComponent } from "./cloud-extract-load-home/cloud-extract-load-home.component";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { SelectComponent } from "./select/select.component";
import { LoadComponent } from "./load/load.component";
import { SubmitComponent } from "./submit/submit.component";
import { ExtractFromCloudComponent } from "./extract-from-cloud/extract-from-cloud.component";
import { LoadToCloudComponent } from "./load-to-cloud/load-to-cloud.component";
import { ConfigPopupComponent } from "./config-popup/config-popup.component";
import { DataService } from "src/app/features/dfte-grid-view/config/data.service";
import { NgxPaginationModule } from 'ngx-pagination';
import { UploadComponent } from './upload/upload.component';

const routes: Routes = [
  {
    path: "",
    component: ColudExtractComponent,
    children: [
      { path: "", component: CloudExtractLoadHomeComponent, pathMatch: "full" },
      {
        path: "load-to-cloud", component: LoadToCloudComponent,
        children: [
          { path: "load", component: LoadComponent },
          { path: "submit", component: SubmitComponent },
          { path: "select", component: SelectComponent },
          { path: "upload", component: UploadComponent }
        ]
      },
    ]
  }
];
@NgModule({
  declarations: [
    ColudExtractComponent,
    CloudExtractLoadHomeComponent,
    SelectComponent,
    LoadComponent,
    SubmitComponent,
    ExtractFromCloudComponent,
    LoadToCloudComponent,
    ConfigPopupComponent,
    UploadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ColudExtractLoadModule { }
